import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
/* import SuccessHandler from '../SuccessHandler' */

/* private CashFlow Types */
import {
  Settings,
  _CashFlow
} from '../namespace-helper'

// selected item template

export default {
  namespaced: true,
  state: {
    cashFlows: {
      monthly_purchase_order_income: [],
      monthly_supplier_to_pay: [],
      monthly_invoice_income: [],
      suppliers_to_pay: []
    }

  },
  mutations: {
    [_CashFlow.mutations.setCashFlows] (state, payload) {
      state.cashFlows = payload
      console.log(payload)
    }
  },
  actions: {
    [_CashFlow.actions.loadCashFlows] (context, payload) {
      /* console.log('loadCashFlows: ' + JSON.stringify(payload))
      console.log('loadCashFlows: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)
*/
      var url = API_URL + '/api/v1/cashflow' +
                '?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&customersId=' + payload.customers_id +
                '&suppliersId=' + payload.suppliers_id +
                (payload.selectedFrom ? '&selectedFrom=' + payload.selectedFrom : '') +
                (payload.selectedTo ? '&selectedTo=' + payload.selectedTo : '') +

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_CashFlow.mutations.setCashFlows, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_CashFlow.actions.resetState] ({ commit }, payload) {
      commit(_CashFlow.mutations.setCashFlows, [])
    }
  },
  getters: {
    [_CashFlow.getters.cashFlow] (state) {
      return state.cashFlows
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/CashFlow/cashFlow.js